module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/45.4438a688.png";